import {createAsyncThunk} from '@reduxjs/toolkit';
import {axiosBffFetch} from '../axios/axiosBffFetch';
import {ApiStatusCodeVo} from '../common/shared/api/nicolas/vo/enums/ApiStatusCodeVo.enum';
import {
  createUpdateProfileImageInfo,
  UpdateProfileImageResult,
} from '../graphql/factory/UserProfile';
import {AppState} from '../state/store';
import {USER_STATE_NAME} from './constants';

export const updateProfileImage = createAsyncThunk<
  UpdateProfileImageResult,
  {
    image?: File;
    isUsedDefaultImage: boolean;
  },
  {state: AppState; rejectValue: UpdateProfileImageResult}
>(
  `${USER_STATE_NAME}/updateProfileImage`,
  async ({image, isUsedDefaultImage}, {rejectWithValue}) => {
    const formData = new FormData();
    formData.append('is_delete', isUsedDefaultImage ? 'Y' : 'N');
    if (image) {
      formData.append('image', image);
    }
    const result = await axiosBffFetch('/api/profile-image', {
      method: 'POST',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    const updateProfileImageInfo = createUpdateProfileImageInfo(result.data);
    if (updateProfileImageInfo.resultCode !== ApiStatusCodeVo.Success) {
      return rejectWithValue(updateProfileImageInfo);
    }

    return updateProfileImageInfo;
  }
);
